import { LitElement, html, css, nothing } from 'lit';
import { base, cards } from '../styles.js';
import { DOCUMENT_STATES } from '../states.js';

/**
 * What became of the documents the officer picked, shown inside the processing view (F2).
 *
 * Four states, and the one that earns this component is `partial`: some files reached us and some
 * did not. The officer can fix that themselves by re-attaching in Encompass, but only if we name
 * which ones — so the failed names are listed and the successful ones deliberately are not.
 *
 * Counts come from the BFF on every poll rather than being accumulated here, so a retry that
 * staged more documents since the last poll simply shows a higher number.
 */
export class DocumentsPanel extends LitElement {
  static properties = {
    received: { type: Number },
    failed: { type: Number },
    expected: { type: Number },
    failedNames: { type: Array },
  };

  static styles = [base, cards, css`
    :host { display: block; }
    .names { margin: 6px 0 0; padding-left: 18px; }
    .names li { font-size: 13px; }
  `];

  constructor() {
    super();
    this.received = 0;
    this.failed = 0;
    this.expected = 0;
    this.failedNames = [];
  }

  /** Which of the four states we are in. Order matters: partial beats pulling. */
  get phase() {
    if (this.failed > 0) return 'partial';
    if (this.expected === 0) return 'none';
    if (this.received < this.expected) return 'pulling';
    return 'received';
  }

  render() {
    const phase = this.phase;
    const spec = DOCUMENT_STATES[phase];
    const names = Array.isArray(this.failedNames) ? this.failedNames.filter(Boolean) : [];

    return html`
      <div class="card">
        <div class="card-head">
          <span class="ch-title">Documents</span>
        </div>
        <div class="card-body">
          <p data-field="documentsSummary">${spec.summary(this)}</p>
          ${phase === 'partial' && names.length
            ? html`
                <ul class="names" data-field="documentsFailedNames">
                  ${names.map((n) => html`<li>${n}</li>`)}
                </ul>
                <p class="note" data-field="documentsHint">${spec.hint}</p>`
            : nothing}
        </div>
      </div>`;
  }
}

customElements.define('documents-panel', DocumentsPanel);
